(function init($) {
  $(document).ready(() => {
    $('.slider-hero').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
    });
    $('.slider-sponsors').slick({
      mobileFirst: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
          },
        },
      ],
    });

    //   $(window).load(() => {
    //     if ($('#subscribe-popup').length > 0) {
    //       $.magnificPopup.open({
    //         items: {
    //           src: '#subscribe-popup'
    //         },
    //         type: 'inline'
    //       }, 0);
    //   }
    // });
  });
}(jQuery));
